import classNames from 'classnames';

import { TextProps } from 'app/components/v2/components/Text';
import Heading6 from 'app/components/v2/components/Text/Heading6';

const Label = (props: TextProps) => {
  return (
    <Heading6
      as="label"
      display="block"
      marginBottom={1.5}
      noWrap
      {...props}
      className={classNames(props.className, 'input_label')}
    />
  );
};

export default Label;
